import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from './CartContext';

const CartPage = () => {
  const { cart, removeFromCart, updateQuantity } = useCart();
  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 768);
  const isDesktop = !isMobile;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const parsePrice = (price) => {
    const parsed = parseFloat(String(price).replace(/[^\d.-]/g, ''));
    if (isNaN(parsed)) return 0;
    if (parsed > 1000000000) return parsed / 1000000000;
    if (parsed >= 1000) return parsed / 1000;
    return parsed;
  };

  if (!Array.isArray(cart)) return <p>Chargement...</p>;
  const formatPrice = (price) => {
    if (price == null) return "0.000";
    return new Intl.NumberFormat('fr-FR', {
      minimumFractionDigits: 3,
      maximumFractionDigits: 3
    }).format(Number(price));
  };

  // Calculate total
  const total = cart.reduce((sum, item) => {
    const price = Number(item.selectedPrice) || 0;
    const qty = Number(item.quantity) || 1;
    return sum + price * qty;
  }, 0);


  const renderVariation = (item) => {
    if (!item.selectedGout && !item.selectedWeight) return null;

    return (
      <div
        style={{
          fontSize: "12px",
          color: "#777",
          marginTop: "2px",
          marginBottom: "4px",
        }}
      >
        {item.selectedGout && <span>Goût : {item.selectedGout}</span>}
        {item.selectedGout && item.selectedWeight && <span> • </span>}
        {item.selectedWeight && <span>Poids : {item.selectedWeight}</span>}
      </div>
    );
  };


  return (


    <div
      className="cart-page container py-5"
      style={{
        minHeight: "100vh",
        paddingBottom: isMobile ? "180px" : "0", // Increased padding for fixed summary
        paddingTop: isMobile ? "20px" : "40px",
      }}
    >
      {/* HEADER */}
      <div style={{ textAlign: "center", marginBottom: isMobile ? "30px" : "50px" }}>
        <h2
          style={{
            fontWeight: 700,
            fontSize: isMobile ? "1.5rem" : "2.2rem",
            marginBottom: "10px",
            padding: isMobile ? "0 15px" : "0",
          }}
        >
          Vérifiez votre sélection
        </h2>

        <div
          style={{
            width: "60px",
            height: "4px",
            background: "linear-gradient(135deg,#ff41b4,#ff6ec7)",
            margin: "0 auto",
            borderRadius: "4px",
          }}
        />
      </div>

      {cart.length === 0 ? (
        <p className="text-center text-muted fs-5">
          Votre panier est vide.
        </p>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? "20px" : "40px",
            alignItems: "flex-start",
          }}
        >
          {/* LEFT SIDE - ITEMS */}
          <div
            style={{
              flex: 1,
              width: "100%",
              padding: isMobile ? "0 15px" : "0",
            }}
          >
            {cart.map((item) => {
              const price = Number(item.selectedPrice) || 0;
              const qty = Number(item.quantity) || 1;

              return (
                <div
                  key={item.id}
                  style={{
                    display: "flex",
                    flexDirection: isMobile ? "column" : "row",
                    alignItems: isMobile ? "flex-start" : "center",
                    gap: isMobile ? "12px" : "15px",
                    padding: isMobile ? "15px" : "20px 0",
                    borderBottom: "1px solid #f0f0f0",
                    background: isMobile ? "#fff" : "transparent",
                    borderRadius: isMobile ? "12px" : "0",
                    boxShadow: isMobile ? "0 2px 8px rgba(0,0,0,0.06)" : "none",
                    marginBottom: isMobile ? "12px" : "0",
                    position: "relative",
                  }}
                >
                  {/* Delete button - top right on mobile */}
                  <button
                    onClick={() => removeFromCart(item.id)}
                    style={{
                      position: isMobile ? "absolute" : "static",
                      top: isMobile ? "10px" : "auto",
                      right: isMobile ? "10px" : "auto",
                      border: "none",
                      background: isMobile ? "#ffe6ee" : "transparent",
                      width: isMobile ? "28px" : "auto",
                      height: isMobile ? "28px" : "auto",
                      borderRadius: isMobile ? "50%" : "0",
                      fontSize: "16px",
                      color: "#ff4d6d",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    ✕
                  </button>

                  {/* Image and Info Container */}
                  <div
                    style={{
                      display: "flex",
                      gap: isMobile ? "12px" : "15px",
                      alignItems: isMobile ? "flex-start" : "center",
                      width: "100%",
                    }}
                  >
                    {/* Image */}
                    <Link to={`/shop-details/${item.id}`}>
                      <img
                        src={item.image}
                        alt={item.name}
                        style={{
                          width: isMobile ? "90px" : "60px",
                          marginLeft: isMobile ? "90px" : "0",

                          height: isMobile ? "80px" : "60px",
                          objectFit: "cover",
                          borderRadius: "12px",
                          flexShrink: 0,
                        }}
                      />
                    </Link>

                    {/* Info */}
                    <div style={{
                      flex: 1, minWidth: 0, marginLeft: isMobile ? "-80px" : "0",
                    }}>
                      <h6
                        style={{
                          margin: 0,
                          fontWeight: 600,
                          fontSize: isMobile ? "0.95rem" : "0.90rem",
                          marginBottom: "4px",
                          paddingRight: isMobile ? "30px" : "0", // Space for delete button
                        }}
                      >
                        {item.name}
                      </h6>

                      {renderVariation(item)}

                      <div
                        style={{
                          color: "#777",
                          fontSize: isMobile ? "0.85rem" : "0.9rem",
                          marginTop: "4px",
                        }}
                      >
                        {formatPrice(price)} DT
                      </div>

                      {/* Quantity Controls and Total - horizontal on mobile */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          marginTop: "12px",
                          gap: "12px",
                        }}
                      >
                        {/* Quantity Controls */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            background: "#f9f9f9",
                            padding: isMobile ? "4px 10px" : "6px 10px",
                            borderRadius: "12px",
                            boxShadow: isDesktop ? "0 2px 5px rgba(0,0,0,0.08)" : "none",
                          }}
                        >
                          <button
                            onClick={() => updateQuantity(item.id, qty - 1)}
                            disabled={qty <= 1}
                            style={{
                              border: "none",
                              background: isDesktop ? "#eee" : "transparent",
                              fontSize: isMobile ? "16px" : "14px",
                              cursor: qty <= 1 ? "not-allowed" : "pointer",
                              color: qty <= 1 ? "#ccc" : "#ff41b4",
                              width: "28px",
                              height: "28px",
                              borderRadius: "50%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              transition: "all 0.2s",
                            }}
                            onMouseEnter={(e) => { if (qty > 1) e.currentTarget.style.background = "#ffd7e8"; }}
                            onMouseLeave={(e) => { e.currentTarget.style.background = isDesktop ? "#eee" : "transparent"; }}
                          >
                            −
                          </button>

                          <span
                            style={{
                              fontWeight: 600,
                              fontSize: isMobile ? "0.95rem" : "0.85rem",
                              minWidth: "22px",
                              textAlign: "center",
                              color: "#333",
                            }}
                          >
                            {qty}
                          </span>

                          <button
                            onClick={() => updateQuantity(item.id, qty + 1)}
                            style={{
                              border: "none",
                              background: isDesktop ? "#eee" : "transparent",
                              fontSize: isMobile ? "16px" : "14px",
                              color: qty <= 1 ? "#ccc" : "#ff41b4",
                              cursor: "pointer",
                              width: "28px",
                              height: "28px",
                              borderRadius: "50%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              transition: "all 0.2s",
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.background = "#ffd7e8"}
                            onMouseLeave={(e) => e.currentTarget.style.background = isDesktop ? "#eee" : "transparent"}
                          >
                            +
                          </button>
                        </div>

                        {/* Item Total */}
                        <div
                          style={{
                            fontWeight: 700,
                            fontSize: isMobile ? "0.9rem" : "0.9rem",
                            color: "#ff41b4",
                            whiteSpace: "nowrap",
                            padding: "4px 10px",
                            marginLeft: isMobile ? "-20px" : "0"
                          }}
                        >
                          {formatPrice(price * qty)} DT
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* SUMMARY - Fixed at bottom on mobile */}
          <div
            style={{
              width: isMobile ? "100%" : "320px",
              position: isMobile ? "fixed" : "sticky",
              bottom: isMobile ? 0 : "auto",
              top: isMobile ? "auto" : "120px",
              left: isMobile ? 0 : "auto",
              right: isMobile ? 0 : "auto",
              background: "#fff",
              padding: isMobile ? "20px 20px 25px" : "25px",
              boxShadow: isMobile
                ? "0 -8px 30px rgba(0,0,0,0.12)"
                : "0 10px 30px rgba(0,0,0,0.05)",
              borderRadius: isMobile ? "24px 24px 0 0" : "18px",
              zIndex: isMobile ? 1000 : "auto",
            }}
          >
            {/* Total */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontSize: isMobile ? "1.1rem" : "1.2rem",
                fontWeight: 700,
                marginBottom: isMobile ? "15px" : "20px",
                paddingBottom: isMobile ? "15px" : "0",
                borderBottom: isMobile ? "2px solid #f5f5f5" : "none",
              }}
            >
              <span>Total</span>
              <span style={{ color: "#ff41b4" }}>{formatPrice(total)} DT</span>
            </div>

            {/* Checkout Button */}
            <Link
              to="/checkout"
              style={{
                display: "block",
                textAlign: "center",
                background: "linear-gradient(135deg,#ff41b4,#ff6ec7)",
                color: "#fff",
                padding: isMobile ? "16px" : "14px",
                borderRadius: "50px",
                textDecoration: "none",
                fontWeight: 600,
                fontSize: isMobile ? "1rem" : "0.95rem",
                boxShadow: "0 4px 15px rgba(255, 65, 180, 0.3)",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = "translateY(-2px)";
                e.target.style.boxShadow = "0 6px 20px rgba(255, 65, 180, 0.4)";
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow = "0 4px 15px rgba(255, 65, 180, 0.3)";
              }}
            >
              Procéder au paiement
            </Link>

            {/* Optional: Add items count on mobile */}
            {isMobile && (
              <div
                style={{
                  textAlign: "center",
                  marginTop: "10px",
                  fontSize: "0.85rem",
                  color: "#888",
                }}
              >
                {cart.length} article{cart.length > 1 ? "s" : ""} dans votre panier
              </div>
            )}
          </div>
        </div>
      )}
    </div>


  );
};

export default CartPage;
